import React, { useEffect } from 'react';
import { DashboardRouter } from 'router/router';
import { useUserLocation } from 'features/mobile-report/hooks/use-user-location';
import {
    userLocationSignal,
    webViewTokenSignal,
} from 'features/mobile-report/state/mobile-report.signals';
import { SkeletonLoader } from 'utils/skeleton-loader/skeleton-loader';
import { useSetMobileViewportMeta } from 'features/mobile-report/hooks/use-set-mobile-viewport-meta';
import { useRedirectToMobile } from 'features/mobile-report/hooks/use-redirect-to-mobile';
import type { WebviewUserAuth } from 'features/mobile-report/types/types';
import { MobileSidePanel } from 'features/mobile-report/shared/components/mobile-side-panel/mobile-side-panel';
import { mobileSupportPageSignal } from 'features/mobile-report/state/mobile-report.signals';
import { MobileSupportPages } from 'features/mobile-report/shared/components/mobile-support-pages/mobile-support-pages';

import 'shared/styles/elevio-mobile.scss';

const MobileLoader = <SkeletonLoader height="100vh" />;

export const MobileApp = () => {
    const userLocation = useUserLocation();
    const redirectToMobile = useRedirectToMobile();

    useSetMobileViewportMeta();

    useEffect(() => {
        userLocationSignal.value = userLocation;
    }, [userLocation]);

    useEffect(() => {
        window.placerMobile?.webView.hideSplashScreen?.();
    }, []);

    useEffect(() => {
        const handleToken = (token: string) => {
            if (token) {
                const userData = JSON.parse(decodeURIComponent(token)) as WebviewUserAuth;

                webViewTokenSignal.value = userData;
                userData.next_url && redirectToMobile(userData.next_url);
                window.placerMobile?.token.reset();
            }
        };
        window.placerMobile?.token.get(handleToken);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <DashboardRouter AppLoader={MobileLoader} RouteLoader={MobileLoader} />

            <MobileSidePanel isOpen={!!mobileSupportPageSignal.value}>
                <MobileSupportPages />
            </MobileSidePanel>
        </>
    );
};
